export class ImportDataUrlsDto {
  vehicles_csv: string = '';
  vehicles_guide: string = '';
  clients_csv: string = '';
  clients_guide: string = '';
  billing_accounts_csv: string = '';
  billing_accounts_guide: string = '';

  constructor(data?: any) {
    if (data) {
      this.copyFrom(data);
    }
  }

  static fromJson(json: any): ImportDataUrlsDto {
    return new ImportDataUrlsDto(json);
  }

  toJson(): any {
    return {
      vehicles_csv: this.vehicles_csv,
      vehicles_guide: this.vehicles_guide,
      clients_csv: this.clients_csv,
      clients_guide: this.clients_guide,
      billing_accounts_csv: this.billing_accounts_csv,
      billing_accounts_guide: this.billing_accounts_guide
    };
  }

  copyFrom(data: any): void {
    if (!data) return;
    this.vehicles_csv = data.vehicles_csv ?? this.vehicles_csv;
    this.vehicles_guide = data.vehicles_guide ?? this.vehicles_guide;
    this.clients_csv = data.clients_csv ?? this.clients_csv;
    this.clients_guide = data.clients_guide ?? this.clients_guide;
    this.billing_accounts_csv = data.billing_accounts_csv ?? this.billing_accounts_csv;
    this.billing_accounts_guide = data.billing_accounts_guide ?? this.billing_accounts_guide;
  }
}
